import { Divider, Layout, Text } from '@loadsmart/miranda-react'

import { type Commodity as CommodityType } from '../domain/Commodity'
import { getHazmatClass, getHazmatPackingGroup } from '../presenters/CommodityPresenter'
import { formatPackageTypeLabel } from '../presenters/DimensionsPresenter'
import { formatFreightClass, formatWeightString } from '../presenters/HandlingUnitPresenter'
import { SummaryLabel } from './SummaryLabel'

export default function Commodity({ commodity }: { commodity: CommodityType }) {
  return (
    <Layout.Stack gap="spacing-2" padding-t="spacing-2" padding-b="spacing-6" key={commodity.uuid}>
      <Text variant="heading-sm-bold">
        {formatPackageTypeLabel({
          count: Number(commodity.packageCount),
          category: 'commodities',
          description: commodity.description,
          packageType: commodity.packageType,
        })}
      </Text>
      <Divider />
      <Layout.Stack gap="spacing-6">
        <Layout.Grid minColumnWidth="80px">
          <SummaryLabel
            label="Item weight"
            data-testid="weight-summary"
            value={formatWeightString(commodity.weight || 0)}
          />
          <SummaryLabel label="NMFC" data-testid="nmfc-summary" value={commodity.nmfcCode || '-'} />
          <SummaryLabel
            label="Freight class"
            data-testid="freight_class-summary"
            value={formatFreightClass(commodity.freightClass)}
          />
        </Layout.Grid>
        {commodity.hazmat && (
          <Layout.Grid minColumnWidth="130px">
            <SummaryLabel
              label="Proper shipping name"
              data-testid="hazmat_shipping_name-summary"
              value={commodity.hazmatShippingName || '-'}
            />
            <SummaryLabel
              label="Hazmat class"
              data-testid="hazmat_class-summary"
              value={getHazmatClass(commodity)}
            />
            <SummaryLabel
              label="UN number"
              data-testid="hazmat_un_number-summary"
              value={commodity.unNumber || '-'}
            />
            <SummaryLabel
              label="Packing group"
              data-testid="hazmat_packing_group-summary"
              value={getHazmatPackingGroup(commodity)}
            />
          </Layout.Grid>
        )}
      </Layout.Stack>
    </Layout.Stack>
  )
}
